export default "__VITE_ASSET__D0VRxm0g__"